// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';
import iamotaEventHandler from 'assets/scripts/helpers/event-handler';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_accessories-collections-slider.scss';

// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--accessories-collections';
const CAROUSEL_CLASS = 'carousel--accessories-collections';
const CAROUSEL_SECTION_CLASS = 'accessories-collections';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
const SHARPENER_TYPE_PARAM = 'sharpener_type';


class iamAccessoriesCollectionsSlider extends HTMLElement {

    constructor() {
        super();

        this.sectionId = this.dataset.sectionId;

        // Generate unique class for each collection list slider
        this.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${this.sectionId}`);

        // Generate unique btn classes for slider arrows
        this.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${this.sectionId}`);
        this.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${this.sectionId}`);

        // Generate unique btn classes for swiper pagination
        this.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${this.sectionId}`);

        this.swiper = new Swiper(`.${CAROUSEL_CLASS}-${this.sectionId}`, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1000,
            spaceBetween: 10,
            swiper: false,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                788: {
                    slidesPerView: 8,
                    swiper: true,
                    spaceBetween: 15,
                    pagination: {
                        type: 'bullets',
                        clickable: true,
                        el: `.${CAROUSEL_SECTION_CLASS}-pagination-${this.sectionId}`,
                    }
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${this.sectionId}`,
                prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${this.sectionId}`
            }
        });

        this.swiper.slides.forEach((slide, index) => {
            const slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', () => {
                this.swiper.slideTo(index);
            });
        });

        this.querySelectorAll('.filter-link').forEach((link) => {
            const filterType = link.dataset.filterType;

            link.addEventListener('click', (e) => this.onFilterLinkClick(e, filterType));
        });

        iamotaEventHandler.subscribeToEvent('filterPramsUpdated', this.onFilterParamsUpdated.bind(this));

        this.applyInitialFilterFromParams();
    }

    applyInitialFilterFromParams() {
        const requestedFilterType = new URLSearchParams(window.location.search).get(SHARPENER_TYPE_PARAM);

        if (!requestedFilterType) return;

        const filterLinks = this.querySelectorAll('.filter-link');
        const matchingLink = Array.from(filterLinks).find(
            (link) => link.dataset.filterType.toLowerCase() === requestedFilterType.toLowerCase()
        );

        // Missing or unrecognized param falls back to the unfiltered default already rendered in the markup.
        if (!matchingLink) return;

        filterLinks.forEach((link) => link.classList.remove('selected'));
        matchingLink.classList.add('selected');

        this.applyFilter(matchingLink.dataset.filterType);
    }

    onFilterParamsUpdated(e, data) {

        this.swiper.slides.forEach((slide) => {

            const collectionUrl = slide.querySelector('a');

            if (collectionUrl) {
                // Create a URL object from the current href
                const url = new URL(collectionUrl.href);

                // Replace all parameters after "?"
                url.search = data.filterParams;

                // Update the href attribute with the modified URL
                collectionUrl.href = url.href;
            }
        });
    }

    onFilterLinkClick(e, filterType) {
        e.preventDefault();
        const clickedlink = e.target;

        if (!clickedlink.classList.contains('selected')) {

            this.querySelectorAll('.filter-link').forEach((link) => {
                link.classList.remove('selected');
            });
            clickedlink.classList.add('selected');

            this.applyFilter(filterType);
        }
    }

    applyFilter(filterType) {
        this.swiper.slides.forEach((slide) => {

            if (filterType != 'All') {
                const sharpenerType = slide.dataset.sharpenerType;

                if (sharpenerType != filterType) {
                    slide.style.display = 'none';
                } else {
                    slide.style.display = 'list-item';
                }
            } else {
                slide.style.display = 'list-item';
            }
        });

        this.swiper.updateSlides();
    }
}

customElements.define('iam-accessories-collections-slider', iamAccessoriesCollectionsSlider);
